import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { guaranteeSteps } from '../data/offer';
export function Guarantee() {
  return <section className="py-24 px-4 bg-seafoam-light border-y border-seafoam/60" data-id="element-168" data-mp="1o33tsfx1zqh8">
      <div className="max-w-4xl mx-auto text-center" data-id="element-169" data-mp="222dbxl4tkunu">
        <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-forest text-seafoam mb-8" data-id="element-170" data-mp="1x4bsv07e8vcd">
          <ShieldCheck size={52} aria-hidden="true" data-id="element-171" data-mp="19e7p8su7gvld" />
        </div>
        <h2 className="text-3xl md:text-4xl font-display font-extrabold mb-8 text-navy" data-id="element-172" data-mp="19co52r5fi0eb">
          Full 7-Day Money-Back Guarantee
        </h2>
        <ol className="flex flex-wrap justify-center gap-2 mb-8 max-w-3xl mx-auto" data-id="element-173" data-mp="1j4ty847f2nv3">
          {guaranteeSteps.map(step => <li key={step} className="px-4 py-2 rounded-full bg-white border border-seafoam text-forest text-sm font-medium" data-id="element-174" data-mp="1ec98pevjmwxd">
              {step}
            </li>)}
        </ol>
        <div className="space-y-5 text-lg text-muted max-w-2xl mx-auto" data-id="element-175" data-mp="lnc0k4l1qgic">
          <p className="text-ink font-medium" data-id="element-176" data-mp="oz025robrumq">
            If you feel the material is not clear, practical or useful for your MTB coaching
            needs, contact us within 7 days.
          </p>
          <p className="text-forest font-bold text-xl" data-id="element-177" data-mp="ypup6y9eay98">We’ll refund your purchase.</p>
          <p className="text-base" data-id="element-178" data-mp="12pmtuzvo4k9b">
            Because the system should earn its place in your coaching toolkit.
          </p>
        </div>
      </div>
    </section>;
}